module.exports = __webpack_public_path__ + "static/media/shark.628632dd.png";